module.exports = __webpack_public_path__ + "img/take_away.4faa5391.jpg";